module.exports = __webpack_public_path__ + "87f23c5885b8d1e06dc3063466ed2c13.png";